import { ConditionType } from './condition-type';
import { TableRowColorType } from './table-row-color-type';
export class TableRowColor{

    ColumnName: string;
    Condition: ConditionType;
    Value: number;
    Color: string;
    Type?: TableRowColorType = TableRowColorType.Background;
}